import {
  CURRENCY_RATES_FETCH_START,
  CURRENCY_RATES_FETCH_SUCCESS,
  CURRENCY_RATES_FETCH_ERROR,
  CHOSE_TO_CURRENCY_START,
  CHOSE_TO_CURRENCY_SUCCESS,
  CHOSE_TO_CURRENCY_ERROR,
  CHOSE_TO_THEME_START,
  CHOSE_TO_THEME_SUCCESS,
  CHOSE_TO_THEME_ERROR
} from '../../constants';
import { getCurrencyRates as query } from '../../lib/graphql';

const getCurrencyRates = (toCurrency) => {

  return async (dispatch, getState, { client }) => {

    let base, currencyRates;
    try {

      dispatch({
        type: CURRENCY_RATES_FETCH_START,
      });

      const { data } = await client.query({ query });
      if (data?.getCurrencyRates) {
        base = data?.getCurrencyRates?.base;
        if (data.getCurrencyRates.rates != null) {
          currencyRates = JSON.parse(data?.getCurrencyRates?.rates);
        }
        dispatch({
          type: CURRENCY_RATES_FETCH_SUCCESS,
          payload: {
            base,
            to: toCurrency,
            rates: currencyRates
          }
        });
      }
    } catch (error) {
      dispatch({
        type: CURRENCY_RATES_FETCH_ERROR,
        payload: {
          error,
        },
      });
      return false;
    }
    return true;
  };
}


const choseToCurrency = (toCurrency) => {

  return async (dispatch, getState, { client }) => {

    try {

      dispatch({
        type: CHOSE_TO_CURRENCY_START,
      });

      dispatch({
        type: CHOSE_TO_CURRENCY_SUCCESS,
        payload: {
          to: toCurrency
        }
      });

      if (process.env.BROWSER) {
        const maxAge = 3650 * 24 * 3600; // 10 years in seconds
        document.cookie = `currency=${toCurrency};path=/;max-age=${maxAge}`;
      }

    } catch (error) {
      dispatch({
        type: CHOSE_TO_CURRENCY_ERROR,
        payload: {
          error,
        },
      });
      return false;
    }
    return true;
  };
}

const choseToTheme = (theme) => {

  return async (dispatch, getState, { client }) => {

    try {

      dispatch({
        type: CHOSE_TO_THEME_START,
      });

      dispatch({
        type: CHOSE_TO_THEME_SUCCESS,
        payload: {
          theme
        }
      });

      if (process.env.BROWSER) {

        // Situs publik dilewati: temanya dari data-theme="auto" +
        // prefers-color-scheme, bukan class di body. Lihat darkMode.css:3.
        const root = document.documentElement;
        const isPublicSite = root.getAttribute('data-theme') === 'auto';

        /*
         * Dashboard baru di /admin membaca html[data-theme], bukan class di
         * body. Diperbarui di sini supaya kedua dashboard berbagi satu tombol,
         * satu action dan satu cookie — bukan dua sistem tema yang bisa saling
         * bertentangan. Situs publik dilewati: 'auto' berarti ikut OS.
         */
        if (!isPublicSite && root.hasAttribute('data-theme')) {
          root.setAttribute('data-theme', theme === 'dark' ? 'dark' : 'light');
        }

        /*
         * Class di body HANYA untuk dashboard lama. Halaman yang memakai
         * html[data-theme] — situs publik dan dashboard baru — tidak boleh
         * mendapatkannya: `.darkMode a` di darkMode.css mewarnai ulang setiap
         * tautan, dan itu sempat membuat seluruh sidebar baru jadi oranye.
         */
        const usesDataTheme = root.hasAttribute('data-theme');

        if (usesDataTheme) {
          document.body.classList.remove('lightMode', 'darkMode');
        } else if (theme == 'dark') {
          document.body.classList.add('darkMode');
          document.body.classList.remove('lightMode');
        } else {
          document.body.classList.add('lightMode');
          document.body.classList.remove('darkMode');
        }

        const maxAge = 3650 * 24 * 3600; // 10 years in seconds
        document.cookie = `theme=${theme};path=/;max-age=${maxAge}`;
      }
    } catch (error) {
      dispatch({
        type: CHOSE_TO_THEME_ERROR,
        payload: {
          error,
        },
      });
      return false;
    }
    return true;
  };
}

export {
  getCurrencyRates,
  choseToCurrency,
  choseToTheme
};



